export const STORES = [
    {
        id: "1",
        name: "Costco Wholesale Allen",
        address: "1067 State Hwy 121, Allen, TX 75013",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.688749, 33.1385265],
    },
    {
        id: "2",
        name: "Costco Wholesale Bunker Hill",
        address: "1150 Bunker Hill Rd, Houston, TX 77055",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.5303977, 29.78801842465316],
    },
    {
        id: "3",
        name: "Costco Wholesale College Station",
        address: "4321 Texas 6 Frontage Rd, College Station, TX 77845",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.26335069999999, 30.567047199999998],
    },
    {
        id: "4",
        name: "Costco Wholesale Cypress",
        address: "26960 NW Fwy, Cypress, TX 77433",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.712269, 29.978915],
    },
    {
        id: "5",
        name: "Costco Wholesale Dallas",
        address: "8055 Churchill Way, Dallas, TX 75251",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.7683402, 32.919519],
    },
    {
        id: "6",
        name: "Costco Wholesale Georgetown",
        address: "2201a I-35, Georgetown, TX 78628",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.66355259999999, 30.6779415],
    },
    {
        id: "7",
        name: "Costco Wholesale Humble",
        address: "21802 Townsen Blvd W, Humble, TX 77338",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.2668928161198, 30.0221390548929],
    },
    {
        id: "8",
        name: "Costco Wholesale Kyle",
        address: "19086 I-35, Kyle, TX 78640",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.8503276, 30.0318278],
    },
    {
        id: "9",
        name: "Costco Wholesale Midland",
        address: "1901 Kirkland Dr, Midland, TX 79707",
        addressUrl: "",
        state: "TX",
        coordinates: [-102.1765436, 31.993809499999998],
    },
    {
        id: "10",
        name: "Costco Wholesale Pearland",
        address: "3500 Business Center Dr, Pearland, TX 77584",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.3903924746462, 29.5428955694717],
    },
    {
        id: "11",
        name: "Costco Wholesale Prosper",
        address: "5620 W University Dr, Prosper, TX 75078",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.8952975, 33.2219632],
    },
    {
        id: "12",
        name: "Costco Wholesale Rockwall",
        address: "1225 State Hwy 276 #1049c, Rockwall, TX 75032",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.4456817, 32.908041],
    },
    {
        id: "13",
        name: "Costco Wholesale Selma",
        address: "15330 I-35 N, Selma, TX 78154",
        addressUrl: "",
        state: "TX",
        coordinates: [-98.3182549, 29.5765185],
    },
    {
        id: "14",
        name: "Costco Wholesale Sonterra Park",
        address: "1201 N Loop 1604 E, San Antonio, TX 78232",
        addressUrl: "",
        state: "TX",
        coordinates: [-98.4749399, 29.6116958],
    },
    {
        id: "15",
        name: "Costco Wholesale The Woodlands",
        address: "8185 TX-242, The Woodlands, TX 77385",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.4531646, 30.2086923],
    },
    {
        id: "16",
        name: "Costco Wholesale Arlington",
        address: "600 W Arbrook Blvd, Arlington, TX 76014",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.116824, 32.674151],
    },
    {
        id: "17",
        name: "Costco Wholesale Austin",
        address: "10401 Research Blvd, Austin, TX 78759",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.748703, 30.401072],
    },
    {
        id: "18",
        name: "Costco Wholesale Cedar Park",
        address: "4601 183A Toll Rd, Cedar Park, TX 78613",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.820873, 30.526369],
    },
    {
        id: "19",
        name: "Costco Wholesale Duncanville",
        address: "250 W Hwy 67, Duncanville, TX 75137",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.906833, 32.651039],
    },
    {
        id: "20",
        name: "Costco Wholesale East Plano",
        address: "1700 Dallas Pkwy, Plano, TX 75093",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.823624, 33.019826],
    },
    {
        id: "21",
        name: "Costco Wholesale El Paso",
        address: "6101 Gateway Blvd W, El Paso, TX 79925",
        addressUrl: "",
        state: "TX",
        coordinates: [-106.395995, 31.787359],
    },
    {
        id: "22",
        name: "Costco Wholesale Fort Worth",
        address: "5300 Overton Ridge Blvd, Fort Worth, TX 76132",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.414222, 32.673458],
    },
    {
        id: "23",
        name: "Costco Wholesale Frisco",
        address: "11220 Dallas Pkwy, Frisco, TX 75033",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.821381, 33.182217],
    },
    {
        id: "24",
        name: "Costco Wholesale Galleria",
        address: "3836 Richmond Ave, Houston, TX 77027",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.444038, 29.732722],
    },
    {
        id: "25",
        name: "Costco Wholesale Lewisville",
        address: "851 State Hwy 121 Bypass, Lewisville, TX 75067",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.015609, 33.005943],
    },
    {
        id: "26",
        name: "Costco Wholesale Lubbock",
        address: "6100 19th St, Lubbock, TX 79407",
        addressUrl: "",
        state: "TX",
        coordinates: [-101.948159, 33.579804],
    },
    {
        id: "27",
        name: "Costco Wholesale McKinney",
        address: "3650 W University Dr, McKinney, TX 75071",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.663902, 33.219524],
    },
    {
        id: "28",
        name: "Costco Wholesale North Fort Worth",
        address: "8901 Tehama Ridge Pkwy, Fort Worth, TX 76177",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.306801, 32.915848],
    },
    {
        id: "29",
        name: "Costco Wholesale Northwest San Antonio",
        address: "5611 UTSA Blvd, San Antonio, TX 78249",
        addressUrl: "",
        state: "TX",
        coordinates: [-98.597516, 29.576037],
    },
    {
        id: "30",
        name: "Costco Wholesale Pflugerville",
        address: "1901 Kelly Ln, Pflugerville, TX 78660",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.586052, 30.453896],
    },
    {
        id: "31",
        name: "Costco Wholesale Pharr",
        address: "1501 W Kelly Ave, Pharr, TX 78577",
        addressUrl: "",
        state: "TX",
        coordinates: [-98.194281, 26.205351],
    },
    {
        id: "32",
        name: "Costco Wholesale Richmond",
        address: "23645 Katy Fwy, Katy, TX 77494",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.790672, 29.784882],
    },
    {
        id: "33",
        name: "Costco Wholesale South Austin",
        address: "4301 W William Cannon Dr, Austin, TX 78749",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.842675, 30.219376],
    },
    {
        id: "34",
        name: "Costco Wholesale Southlake",
        address: "2601 E State Hwy 114, Southlake, TX 76092",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.110013, 32.954221],
    },
    {
        id: "35",
        name: "Costco Wholesale Sugar Land",
        address: "17520 Southwest Fwy, Sugar Land, TX 77479",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.635643, 29.592955],
    },
    {
        id: "36",
        name: "Costco Wholesale Tomball",
        address: "26960 NW Fwy, Cypress, TX 77433",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.712269, 29.978915],
    },
    {
        id: "37",
        name: "Costco Wholesale West Katy",
        address: "23645 Katy Fwy, Katy, TX 77494",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.790672, 29.784882],
    },
    {
        id: "38",
        name: "Costco Wholesale West Plano",
        address: "3800 Dallas Pkwy, Plano, TX 75093",
        addressUrl: "",
        state: "TX",
        coordinates: [-96.821807, 33.050163],
    },
    {
        id: "39",
        name: "Costco Wholesale West San Antonio",
        address: "191 W Loop 1604 S, San Antonio, TX 78245",
        addressUrl: "",
        state: "TX",
        coordinates: [-98.690736, 29.429442],
    },
    {
        id: "40",
        name: "Costco Wholesale Weatherford",
        address: "3911 E Interstate 20, Weatherford, TX 76087",
        addressUrl: "",
        state: "TX",
        coordinates: [-97.714507, 32.740346],
    },
    {
        id: "41",
        name: "Costco Wholesale Webster",
        address: "1700 W Bay Area Blvd, Webster, TX 77598",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.143265, 29.545002],
    },
    {
        id: "42",
        name: "Costco Wholesale Willowbrook",
        address: "12405 N Gessner Rd, Houston, TX 77064",
        addressUrl: "",
        state: "TX",
        coordinates: [-95.540812, 29.959973],
    },
    {
        id: "43",
        name: "Costco Wholesale Hawaii Kai",
        address: "333 A Keahole Street, Honolulu, HI 96825",
        addressUrl: "",
        state: "HI",
        coordinates: [-157.705819, 21.277843],
    },
    {
        id: "44",
        name: "Costco Wholesale Iwilei",
        address: "525 Alakawa Street, Honolulu, HI 96817",
        addressUrl: "",
        state: "HI",
        coordinates: [-157.870563, 21.318636],
    },
    {
        id: "45",
        name: "Costco Wholesale Kapolei",
        address: "4589 Kapolei Pkwy, Kapolei, HI 96707",
        addressUrl: "",
        state: "HI",
        coordinates: [-158.091639, 21.335987],
    },
    {
        id: "46",
        name: "Costco Wholesale Kauai",
        address: "4300 Nuhou Street, Lihue, HI 96766",
        addressUrl: "",
        state: "HI",
        coordinates: [-159.356151, 21.975227],
    },
    {
        id: "47",
        name: "Costco Wholesale Kona",
        address: "73-5600 Maiau Street, Kailua-Kona, HI 96740",
        addressUrl: "",
        state: "HI",
        coordinates: [-155.984545, 19.677939],
    },
    {
        id: "48",
        name: "Costco Wholesale Maui",
        address: "540 Haleakala Hwy, Kahului, HI 96732",
        addressUrl: "",
        state: "HI",
        coordinates: [-156.454693, 20.880983],
    },
    {
        id: "49",
        name: "Costco Pearl City Home Showroom",
        address: "98-600 Kamehameha Hwy, Pearl City, HI 96782",
        addressUrl: "",
        state: "HI",
        coordinates: [-157.998964, 21.398189],
    },
    {
        id: "50",
        name: "Costco Wholesale Waipio",
        address: "94-1231 Ka Uka Blvd, Waipahu, HI 96797",
        addressUrl: "",
        state: "HI",
        coordinates: [-158.020279, 21.416447],
    },
    {
        id: "51",
        name: "Costco Wholesale Los Feliz",
        address: "2901 Los Feliz Blvd, Los Angeles, CA 90039",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.272973, 34.109318],
    },
    {
        id: "52",
        name: "Costco Wholesale Pacoima",
        address: "13550 Paxton St, Pacoima, CA 91331",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.414382, 34.265386],
    },
    {
        id: "53",
        name: "Costco Wholesale Van Nuys",
        address: "6100 Sepulveda Blvd, Van Nuys, CA 91411",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.466690, 34.183560],
    },
    {
        id: "54",
        name: "Costco Wholesale Woodland Hills",
        address: "21800 Victory Blvd, Woodland Hills, CA 91367",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.601395, 34.186973],
    },
    {
        id: "55",
        name: "Costco Wholesale Northridge",
        address: "8810 Tampa Ave, Northridge, CA 91324",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.553383, 34.233021],
    },
    {
        id: "56",
        name: "Costco Wholesale Inglewood",
        address: "3560 W Century Blvd, Inglewood, CA 90303",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.332407, 33.945673],
    },
    {
        id: "57",
        name: "Costco Wholesale Alhambra",
        address: "2207 W Commonwealth Ave, Alhambra, CA 91803",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.145917, 34.093229],
    },
    {
        id: "58",
        name: "Costco Wholesale Burbank",
        address: "1051 W Burbank Blvd, Burbank, CA 91506",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.321743, 34.180615],
    },
    {
        id: "59",
        name: "Costco Wholesale Culver City",
        address: "13463 Washington Blvd, Marina Del Rey, CA 90292",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.434982, 33.986215],
    },
    {
        id: "60",
        name: "Costco Wholesale Hawthorne",
        address: "14501 Hindry Ave, Hawthorne, CA 90250",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.369167, 33.902918],
    },
    {
        id: "61",
        name: "Costco Wholesale City of Industry",
        address: "17550 Castleton St, City of Industry, CA 91748",
        addressUrl: "",
        state: "CA",
        coordinates: [-117.915799, 33.994566],
    },
    {
        id: "62",
        name: "Costco Wholesale Commerce Business Center",
        address: "6333 Telegraph Rd, Commerce, CA 90040",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.146496, 34.002647],
    },
    {
        id: "63",
        name: "Costco Wholesale Torrance",
        address: "2640 Lomita Blvd, Torrance, CA 90505",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.330046, 33.798931],
    },
    {
        id: "64",
        name: "Costco Wholesale Lancaster",
        address: "1141 W Avenue L, Lancaster, CA 93534",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.150941, 34.676327],
    },
    {
        id: "65",
        name: "Costco Wholesale Santa Clarita",
        address: "18649 Via Princessa, Santa Clarita, CA 91387",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.438953, 34.421174],
    },
    {
        id: "66",
        name: "Costco Wholesale Norwalk",
        address: "12324 Hoxie Ave, Norwalk, CA 90650",
        addressUrl: "",
        state: "CA",
        coordinates: [-118.072452, 33.909313],
    },
    {
        id: "67",
        name: "Costco Wholesale Azusa",
        address: "1220 W Foothill Blvd, Azusa, CA 91702",
        addressUrl: "",
        state: "CA",
        coordinates: [-117.924142, 34.133785],
    },
    {
        id: "68",
        name: "Costco Wholesale Anchorage",
        address: "330 W Dimond Blvd, Anchorage, AK 99515",
        addressUrl: "",
        state: "AK",
        coordinates: [-149.889648, 61.143822],
    },
    {
        id: "69",
        name: "Costco Anchorage Home Showroom",
        address: "8600 King Street, Anchorage, AK 99515",
        addressUrl: "",
        state: "AK",
        coordinates: [-149.884748, 61.141979],
    },
    {
        id: "70",
        name: "Costco Wholesale Fairbanks",
        address: "48 College Rd, Fairbanks, AK 99701",
        addressUrl: "",
        state: "AK",
        coordinates: [-147.716375, 64.845492],
    },
    {
        id: "71",
        name: "Costco Wholesale Juneau",
        address: "5225 Commercial Blvd, Juneau, AK 99801",
        addressUrl: "",
        state: "AK",
        coordinates: [-134.574531, 58.359005],
    },
    {
        id: "72",
        name: "Costco Wholesale NE Anchorage",
        address: "4125 Debarr Rd, Anchorage, AK 99508",
        addressUrl: "",
        state: "AK",
        coordinates: [-149.802215, 61.213665],
    },
    {
        id: "73",
        name: "Costco Wholesale Caguas",
        address: "200 Ave Rafael Cordero PR-30, Caguas, PR 00725",
        addressUrl: "",
        state: "PR",
        coordinates: [-76, 25],
    },
    {
        id: "74",
        name: "Costco Wholesale Carolina",
        address: "1185 Ave 65 Infanteria, Carolina, PR 00987",
        addressUrl: "",
        state: "PR",
        coordinates: [-77, 24],
    },
    {
        id: "75",
        name: "Costco Wholesale E Bayamon",
        address: "125 Calle A, Bayamon, PR 00959",
        addressUrl: "",
        state: "PR",
        coordinates: [-74.8, 24.5],
    },
    {
        id: "76",
        name: "Costco Puerto Rico Home Showroom",
        address: "Carr 176 KM 0.5, San Juan, PR 00926",
        addressUrl: "",
        state: "PR",
        coordinates: [-75, 23.5],
    },
    {
        id: "77",
        name: "Costco Wholesale W Bayamon",
        address: "PR-2 KM 15.5, Bayamon, PR 00959",
        addressUrl: "",
        state: "PR",
        coordinates: [-76, 23.5],
    },
];
